import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditStoreReady} from '../redux/stores'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'


//import {CostCenters} from './DropDowns/index'
//import {Employees} from './DropDowns/index'


import {BrandsByKitchen,EntityStatus} from '../../../common/DropDowns/index'


import TimePicker from 'react-time-picker'
//import * as Helpers from '../../../common/helpers'


class AddEditStore extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,
        clearIcon:null,
        kitchenData:{},
        storeData:{},
        storeTimings:[],
        platformsListData:[],

        storeName: "",
        brandName: "",
        brandId:null,
        upId: "",   
        status: "",

        remarks:"",
        businessStatus: "",
        budgetedKs: "",
    
        budgetedKsErrorText: false,
        budgetedKsErrorData: '',                                                                                 
    
        upIdErrorText: false,
        upIdErrorData: '', 
        
        brandIdErrorText: false,
        brandIdErrorData: '',

        brandNameErrorText: false,
        brandNaemErrorData: '',

        storeNameErrorText: false,
        storeNameErrorData: '',

        statusErrorText: false,
        statusErrorData: '',

        businessStatusErrorText: false,
        businessStatusErrorData: '',


        remarksErrorText: false,
            remarksErrorData: '',

         
                                                
                                            
        subTitle: Constants.ADD_STORE

    }

    this.isComponentStillMounted = true

    this.brandIdComponent = null
    this.brandIdSection = null

    this.brandNameComponent = null
    this.brandNameSection = null

    this.storeNameComponent = null
    this.storeNameSection = null
                                           
    this.upIdComponent = null
    this.upIdSection = null

    this.statusComponent = null
    this.statusSection = null

    this.budgetedKsComponent = null
    this.budgetedKsSection = null

    this.businessStatusComponent = null
    this.businessStatusSection = null


     this.remarksComponent = null
        this.remarksSection = null


        
}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditStoreReady(false))

    if (this.props.stores && this.props.stores.addEditStoreSelectedId && this.props.stores.addEditStoreSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_STORE))
        this.props.dispatch(subHeaderDataUpdate())
        this.setState({
            subTitle: "Edit Store",
            editFlag:true
        })
    } else if (this.props.stores && this.props.stores.addEditStoreKitchenData && this.props.stores.addEditStoreKitchenData !== null) {
        this.props.dispatch(headerDataUpdate(Constants.ADD_STORE))
        this.props.dispatch(subHeaderDataUpdate())
        this.setState({
            subTitle: "Add Store"
        })
    }
    
    

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.stores && this.props.stores.addEditStoreSelectedId && this.props.stores.addEditStoreSelectedId !== null) {
        this.getStoreById(this.props.stores.addEditStoreSelectedId)
    }else if (this.props.stores && this.props.stores.addEditStoreKitchenData && this.props.stores.addEditStoreKitchenData !== null) {

        this.setState({
            kitchenData: this.props.stores.addEditStoreKitchenData
        });

        this.props.dispatch(addEditStoreReady(true))

    }else{
        this.props.history.push("/dashboard/kitchens/list")
    }
}

componentDidMount() {

        this.storeNameSection = ReactDOM.findDOMNode(this.refs.storeNameSection)
        this.brandIdSection = ReactDOM.findDOMNode(this.refs.brandIdSection)
        this.brandNameSection = ReactDOM.findDOMNode(this.refs.brandNameSection)
        this.upIdSection = ReactDOM.findDOMNode(this.refs.upIdSection)
        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)
        this.budgetedKsSection = ReactDOM.findDOMNode(this.refs.budgetedKsSection)
        this.businessStatusSection = ReactDOM.findDOMNode(this.refs.businessStatusSection)
        this.remarksSection = ReactDOM.findDOMNode(this.refs.remarksSection)

}



updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 120) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}

 getPlatformsComboList=(id,platformsList=[])=>{
         apiService.getPlatformsComboList(id)
                .then(responseData => {
                    this.props.dispatch(addEditStoreReady(true))
                    if(this.isComponentStillMounted && responseData.status === "SUCCESS") {
                         let list = {}
                            list = Object.keys(responseData.data).map((value,index) => {
                                
                                return {
                                    name : responseData.data[value],
                                    platform_id : value,
                                    available : false                                }
                            })
                            list.sort((a,b) => a.name.localeCompare(b.name));

                            if(this.state.editFlag){
                                 for(let i=0;i<platformsList.length;i++){
                                    for(let j=0;j<list.length;j++){
                                        if(parseInt(list[j]['platform_id'],10)===platformsList[i]['platform_id']){
                                            list[j]['id']=platformsList[i]['id']
                                            list[j]['available']=true
                                        }
                                    }
                                }
                            }

                           
                            this.setState({
                                platformsListData: list,
                            });
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(addEditStoreReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Getting store groups got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                        }
                    })
                })
        
    }




brandChange= (data) => {
    this.brandIdComponent.value=data.value
    
        this.setState({
            brandId :data.value,
            brandName :data.label,
            brandIdErrorText: false,
            brandIdErrorData: ''
        },() => {
            if(data.value!==null && data.value!==undefined && data.value!==""){
                this.storeNameComponent.value=data.label+" - "+this.state.kitchenData.kitchen_name
                this.setState({                
                    storeName : data.label+" - "+this.state.kitchenData.kitchen_name
                })

                this.props.dispatch(addEditStoreReady(false))
                this.getPlatformsComboList(data.value)
            }

        })
        this.brandIdSection.className= this.brandIdSection.className.replace(" has-error", "")
    }

    entityStatusChange= (data) => {
    
        this.statusComponent.value=data.value
    
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
            
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }

    businessStatusChange= (data) => {
    
        this.businessStatusComponent.value=data.value
    
        this.setState({
            businessStatus :data.value,
            businessStatusErrorText: false,
            businessStatusErrorData: ''
        })
            
        this.businessStatusSection.className= this.businessStatusSection.className.replace(" has-error", "")
    }

    


    startTimeChange = (value, e,c_index) => {

        let storeTimings = this.state.storeTimings;

        storeTimings.map(function(item, index) {
            if (c_index === index) {
                item.start_time = value
            }
            return true
        })

         this.setState({
            storeTimings: storeTimings
        });

    }

     addTimingBtn = () => {

        let storeTimings = this.state.storeTimings;

        var obj={
            start_time:"10:00",
            end_time:"11:00",
            end_day:false
        }

        storeTimings.push(obj);

        this.setState({
            storeTimings: storeTimings
        });


     }

    


    endTimeChange = (value, e,c_index) => {

        let storeTimings = this.state.storeTimings;

        storeTimings.map(function(item, index) {
            if (c_index === index) {
                item.end_time = value
            }
            return true
        })

         this.setState({
            storeTimings: storeTimings
        });

    }

    checkBoxChange = (c_index,e) => {

        let storeTimings = this.state.storeTimings;

        storeTimings.map(function(item, index) {
            if (c_index === index) {
                item.end_day = e.target.checked
            }
            return true
        })

         this.setState({
            storeTimings: storeTimings
        });

    }

     removeStoreTiming = (c_index) => {

        let storeTimings = this.state.storeTimings;

        storeTimings.splice(c_index, 1);

        this.setState({
            storeTimings: storeTimings
        });

    }

    

mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditStoreReady(false))
    let data = {}

    if(!this.state.editFlag){

        let brandIdObject = this.mandateValidation("brandId", Constants.FORM_SELECT)
        if (brandIdObject.status) {
            data.brand_id = this.brandIdComponent.value
        } else {
            this.props.dispatch(addEditStoreReady(true))
            return
        }

        let storeNameObject = this.mandateValidation("storeName", Constants.FORM_INPUT)
        if (storeNameObject.status) {
            data.name = this.storeNameComponent.value
        } else {

             this.props.dispatch(addEditStoreReady(true))
            return
        }

        data.kitchen_id=this.state.kitchenData.id

    }

    let upIdObject = this.mandateValidation("upId", Constants.FORM_INPUT)
    if (upIdObject.status) {
        data.urbanpiper_id = this.upIdComponent.value
    } else {

         this.props.dispatch(addEditStoreReady(true))
        return
    }


    // let budgetedKsObject = this.mandateValidation("budgetedKs", Constants.FORM_INPUT)
    // if (budgetedKsObject.status) {
    //     data.budgeted_ks = this.budgetedKsComponent.value
    // } else {

    //      this.props.dispatch(addEditStoreReady(true))
    //     return
    // }


    let statusObject = this.mandateValidation("status", Constants.FORM_SELECT)
    if (statusObject.status) {
        data.status = this.statusComponent.value
    } else {
        this.props.dispatch(addEditStoreReady(true))
        return
    }

    let sbusinessStatusObject = this.mandateValidation("businessStatus", Constants.FORM_SELECT)
    if (sbusinessStatusObject.status) {
        data.business_status = this.businessStatusComponent.value
    } else {
        this.props.dispatch(addEditStoreReady(true))
        return
    }

    data.business_remarks=this.remarksComponent.value
    



                

    let apiPayloadData=data;
    
    if(this.state.editFlag){
        this.callAPICall(apiPayloadData)
    }else{

        if(this.state.storeTimings.length===0){
             this.props.dispatch(addEditStoreReady(true))
            this.dialog.show({
                                title: "Error!!",
                                body: "Please add store timings",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })
                return false
        }else{
            if(this.checkTimingFilter()){              
                this.checkOverLapTiming(apiPayloadData);

            }else{
                 this.props.dispatch(addEditStoreReady(true))
                 return false
            }   
        }

    }
    

}





     checkOverLapTiming=(apiPayloadData)=>{

        if(this.state.storeTimings.length>1){

        let first_startime=parseInt(this.state.storeTimings[0].start_time.split(":").join(""),10)
        let first_endtime=parseInt(this.state.storeTimings[0].end_time.split(":").join(""),10)

                                let first_end_day=""

                                if(this.state.storeTimings[0].end_day){
                                    first_end_day="NEXT_DAY"
                                }else{
                                    first_end_day="CURRENT_DAY"
                                }
        
                                let overLappingflag=false;
                                let overLappingTimes="";

                                let second_start_time=parseInt(this.state.storeTimings[1].start_time.split(":").join(""),10)
                                let second_end_time=parseInt(this.state.storeTimings[1].end_time.split(":").join(""),10)

                                let second_end_day=""

                                if(this.state.storeTimings[1].end_day){
                                    second_end_day="NEXT_DAY"
                                }else{
                                    second_end_day="CURRENT_DAY"
                                }
                                

                                if(second_end_day==="CURRENT_DAY" && first_end_day==="CURRENT_DAY"){

                                    if((first_startime>=second_start_time && first_startime<=second_end_time) || (first_endtime>=second_start_time && first_endtime<=second_end_time)){
                                        overLappingflag=true;
                                        overLappingTimes=overLappingTimes+second_start_time+" to "+second_end_time+"; ";
                                    }

                                }else if(second_end_day==="NEXT_DAY" && first_end_day==="CURRENT_DAY"){

                                    if((first_startime>=second_start_time && first_startime<=2359) || (first_endtime>=second_start_time && first_endtime<=2359) || (first_startime>=0 && first_startime<=second_end_time) || (first_endtime>=0 && first_endtime<=second_end_time)){
                                        overLappingflag=true;
                                        overLappingTimes=overLappingTimes+second_start_time+" to "+second_end_time+"; ";
                                    }

                                }else if(second_end_day==="CURRENT_DAY" && first_end_day==="NEXT_DAY"){

                                    if((first_startime<=second_start_time && 2359>=second_start_time) || (first_startime<=second_end_time && 2359>=second_end_time) || (0<=second_start_time && 0>=second_start_time) || (first_endtime<=second_end_time && first_endtime>=second_end_time)){
                                        overLappingflag=true;
                                        overLappingTimes=overLappingTimes+second_start_time+" to "+second_end_time+"; ";
                                    }

                                }else if(second_end_day==="NEXT_DAY" && first_end_day==="NEXT_DAY"){

                                    if((first_startime>=second_start_time && first_startime<=2359) || (first_endtime>=second_start_time && first_endtime<=2359) || (first_startime>=0 && first_startime<=second_end_time) || (first_endtime>=0 && first_endtime<=second_end_time) || (first_startime<=second_start_time && 2359>=second_start_time) || (first_startime<=second_end_time && 2359>=second_end_time) || (0<=second_start_time && 0>=second_start_time) || (first_endtime<=second_end_time && first_endtime>=second_end_time)){
                                        overLappingflag=true;
                                        overLappingTimes=overLappingTimes+second_start_time+" to "+second_end_time+"; ";
                                    }

                                }
                            


                            if(overLappingflag){
                                this.overLappingMsg(overLappingTimes)
                            }else{
                                this.callAPICall(apiPayloadData);
                            }
                       

        }else{
            this.callAPICall(apiPayloadData);
        }
    }


     overLappingMsg=(overLappingTimes)=>{

          this.props.dispatch(addEditStoreReady(true))  
                        this.dialog.show({
                            title: "Error!!",
                            body: "Given time is overlapping other time slots ( "+overLappingTimes+" ). Please check and use other time range",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
    }

    callAPICall=(apiPayloadData)=>{

        

        if(!this.state.editFlag){

            let storeTimings = this.state.storeTimings;
            storeTimings.map(function(item, index) {
                if (item.end_day) {
                    item.end_day="NEXT_DAY"
                }else{
                    item.end_day="CURRENT_DAY"
                }
                return true
            })

            apiPayloadData.timings=storeTimings
        }


    if(this.state.editFlag){
         apiPayloadData.store_platforms=[];

    for (var i = 0; i < this.state.platformsListData.length; i++) {
        if(!this.state.platformsListData[i]['available'] && this.state.platformsListData[i]['id']!==undefined && this.state.platformsListData[i]!==""){
            apiPayloadData.store_platforms.push({"id":this.state.platformsListData[i]['id'],"deleted_flag":true})
        }else if(this.state.platformsListData[i]['available'] && (this.state.platformsListData[i]['id']===undefined || this.state.platformsListData[i]==="")){
            apiPayloadData.store_platforms.push({"platform_id":this.state.platformsListData[i]['platform_id']})
        }
    }


        apiService.editStore(apiPayloadData,this.state.storeData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditStoreReady(true))
                        this.props.history.goBack();
                        //this.props.history.push("/dashboard/kitchens/list")
                    } else {

                        this.props.dispatch(addEditStoreReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditStoreReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiPayloadData.store_platforms=[];

    for (let i = 0; i < this.state.platformsListData.length; i++) {
        if(this.state.platformsListData[i]['available']){
            apiPayloadData.store_platforms.push({"platform_id":this.state.platformsListData[i]['platform_id']})
        }
    }

    apiService.addStore(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditStoreReady(true))
                        this.props.history.goBack();
                        //this.props.history.push("/dashboard/kitchens/list")
                    } else {

                        this.props.dispatch(addEditStoreReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditStoreReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }

}




checkTimingFilter = () => {

    for (var i = 0; i < this.state.storeTimings.length; i++) {
        let selectArr=this.state.storeTimings[i]
        


     if(selectArr.start_time==='' || selectArr.start_time===undefined || selectArr.start_time===null){
           
            this.dialog.show({
                            title: "Error!!",
                            body: "Please provide start time in 24 hours format",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

        if(selectArr.end_time==='' || selectArr.end_time===undefined || selectArr.end_time===null){
            
            this.dialog.show({
                            title: "Error!!",
                            body: "Please provide end time in 24 hours format",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

        if(parseInt(selectArr.start_time.split(":").join(""),10)<0 || parseInt(selectArr.start_time.split(":").join(""),10)>=2400){
           
            this.dialog.show({
                            title: "Error!!",
                            body: "Start time should fall  in between 00 to 23 Hrs",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

        if(parseInt(selectArr.end_time.split(":").join(""),10)<0 || parseInt(selectArr.end_time.split(":").join(""),10)>=2400){
            
            this.dialog.show({
                            title: "Error!!",
                            body: "End time should fall  in between 00 to 23 Hrs",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }


        if(parseInt(selectArr.end_time.split(":").join(""),10)-parseInt(selectArr.start_time.split(":").join(""),10)<60 && !selectArr.end_day){
             

            this.dialog.show({
                            title: "Error!!",
                            body: "Start and end time should have minimum 1 hour range",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

    }
    return true
}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getStoreById = (id) => {
    apiService.getStoreById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        storeData: responseData.data,
                        upId:responseData.data.urbanpiper_id,
                        //budgetedKs:responseData.data.budgeted_ks,
                        status:responseData.data.status,       
                        businessStatus:responseData.data.business_status,
                        remarks:responseData.data.business_remarks             
                    })

                    if (this.isComponentStillMounted) {
                        this.upIdComponent.value=responseData.data.urbanpiper_id
                        //this.budgetedKsComponent.value=responseData.data.budgeted_ks
                        this.statusComponent.value=responseData.data.status
                        this.businessStatusComponent.value=responseData.data.business_status
                        this.remarksComponent.value=responseData.data.business_remarks

                    }


                    this.getPlatformsComboList(responseData.data.brand_id,responseData.data.store_platforms)

                    //this.props.dispatch(addEditStoreReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditStoreReady(true))
        })
}



 costCentersChange = (data) => {
    this.costCenterComponent.value=data.value
        this.setState({
            costCenter :data.value,
            costCenterErrorText: false,
            costCenterErrorData: ''
        })
        this.costCenterSection.className= this.costCenterSection.className.replace(" has-error", "")
    }



 employeeChange = (data) => {
    this.headComponent.value=data.value
        this.setState({
            head :data.value,
            headErrorText: false,
            headErrorData: ''
        })
        this.headSection.className= this.headSection.className.replace(" has-error", "")
    }



checkBoxPlaformChange = (platform_id,e) => {

    let platformsListData = this.state.platformsListData;


    platformsListData.map(function(item, index) {

        if (item['platform_id'] === platform_id) {
            item.available = e.target.checked                   
        }

        return true
    })

     this.setState({
        platformsListData: platformsListData
    });

}

    







    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                    
                                    {(() => {
                                        if(!this.state.editFlag){
                                            return (

                                        <div className="row">
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen Name</label>
                                                    <div className="col-sm-9">
                                                        {this.state.kitchenData.kitchen_name}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.brandIdSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select Brand *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.brandIdComponent = el}>
                                                              <BrandsByKitchen kitchen_id={this.state.kitchenData.id} brandChange={this.brandChange} selectedValue={this.state.brandId} />
                                                              <span className="help-block" style={{ display: this.state.brandIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.brandIdErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                            </div>
                                        </div>

                                         )
                                        }
                                })()}

                                {(() => {
                                        if(this.state.brandId && this.state.brandId!=="" && this.state.brandId!==null && this.state.brandId!==undefined && !this.state.editFlag){
                                            return (
                                                <div className="row">
                                                
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                     <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.storeNameSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Store Name *</label>
                                                           <div className="col-sm-9">
                                                              <input className="form-control" placeholder="Enter Store Name" type="text" ref={el => this.storeNameComponent = el}
                                                              onChange={(e) => {e.preventDefault() 
                                                              this.keyedInputChange("storeName")}} />
                                                              <span className="help-block" style={{ display: this.state.storeNameErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.storeNameErrorData}
                                                              </span>
                                                           </div>
                                                        </div>
                                                     </div>
                                                </div>

                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                     <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.upIdSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>UP Id *</label>
                                                           <div className="col-sm-9">
                                                              <input className="form-control" placeholder="Enter UrbanPiper Id" type="number" ref={el => this.upIdComponent = el}
                                                              onChange={(e) => {e.preventDefault() 
                                                              this.keyedInputChange("upId")}} />
                                                              <span className="help-block" style={{ display: this.state.upIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.upIdErrorData}
                                                              </span>
                                                           </div>
                                                        </div>
                                                     </div>
                                                </div>

                                            {/*

                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group" ref={el =>
                                                               this.budgetedKsSection = el}>
                                                               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Budgeted KS *</label>
                                                               <div className="col-sm-9">
                                                                  <input className="form-control" placeholder="Enter Budgeted Kitchen Staff" type="number" ref={el => this.budgetedKsComponent = el}
                                                                  onChange={(e) => {e.preventDefault() 
                                                                  this.keyedInputChange("budgetedKs")}} />
                                                                  <span className="help-block" style={{ display: this.state.budgetedKsErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                  {this.state.budgetedKsErrorData}
                                                                  </span>
                                                               </div>
                                                            </div>
                                                         </div>
                                                    </div>

                                                */}

                                               <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.statusSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.statusComponent = el}>
                                                              <EntityStatus type="STORES" entityStatusChange={this.entityStatusChange} selectedValue={this.state.status} />
                                                              <span className="help-block" style={{ display: this.state.statusErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.statusErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                                </div>

                                               <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.businessStatusSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Business Status *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.businessStatusComponent = el}>
                                                              <EntityStatus type="BUSINESS_STATUS" entityStatusChange={this.businessStatusChange} selectedValue={this.state.businessStatus} />
                                                              <span className="help-block" style={{ display: this.state.businessStatusErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.businessStatusErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                                </div>


                                                 <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Business Remarks *</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter Business Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>




                                                
                                            </div>

                                            )
                                        }
                                })()}


                                 {(() => {
                                        if(this.state.editFlag){
                                            return (
                                                <div className="row">

                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                 <div className="col-md-6 col-sm-12 col-xs-12">
                                                      <div className="form-group">
                                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Store Name :</label>
                                                         <div className="col-sm-9">
                                                            {(() => {
                                                                if(this.state.storeData && this.state.storeData.name && this.state.storeData.name!==undefined){
                                                                    return(
                                                                        <p>{this.state.storeData.name}</p>
                                                                    )
                                                                }else{
                                                                    return(
                                                                        <p>NA</p>
                                                                    )
                                                                }
                                                            })()}                                         
                                                         </div>
                                                      </div>
                                                   </div>
                                                 </div>

                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                 <div className="col-md-6 col-sm-12 col-xs-12">
                                                      <div className="form-group">
                                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen :</label>
                                                         <div className="col-sm-9">
                                                            {(() => {
                                                                if(this.state.storeData && this.state.storeData.kitchen && this.state.storeData.kitchen.name && this.state.storeData.kitchen.name!==undefined){
                                                                    return(
                                                                        <p>{this.state.storeData.kitchen.name}</p>
                                                                    )
                                                                }else{
                                                                    return(
                                                                        <p>NA</p>
                                                                    )
                                                                }
                                                            })()}                                         
                                                         </div>
                                                      </div>
                                                   </div>
                                                 </div>

                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                 <div className="col-md-6 col-sm-12 col-xs-12">
                                                      <div className="form-group">
                                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Brand :</label>
                                                         <div className="col-sm-9">
                                                            {(() => {
                                                                if(this.state.storeData && this.state.storeData.brand && this.state.storeData.brand.name && this.state.storeData.brand.name!==undefined){
                                                                    return(
                                                                        <p>{this.state.storeData.brand.name}</p>
                                                                    )
                                                                }else{
                                                                    return(
                                                                        <p>NA</p>
                                                                    )
                                                                }
                                                            })()}                                         
                                                         </div>
                                                      </div>
                                                   </div>
                                                 </div>

                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                     <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.upIdSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>UP Id *</label>
                                                           <div className="col-sm-9">
                                                              <input className="form-control" placeholder="Enter UrbanPiper Id" type="number" ref={el => this.upIdComponent = el}
                                                              onChange={(e) => {e.preventDefault() 
                                                              this.keyedInputChange("upId")}} />
                                                              <span className="help-block" style={{ display: this.state.upIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.upIdErrorData}
                                                              </span>
                                                           </div>
                                                        </div>
                                                     </div>
                                                </div>

                                                {/*

                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group" ref={el =>
                                                               this.budgetedKsSection = el}>
                                                               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Budgeted KS *</label>
                                                               <div className="col-sm-9">
                                                                  <input className="form-control" placeholder="Enter Budgeted Kitchen Staff" type="number" ref={el => this.budgetedKsComponent = el}
                                                                  onChange={(e) => {e.preventDefault() 
                                                                  this.keyedInputChange("budgetedKs")}} />
                                                                  <span className="help-block" style={{ display: this.state.budgetedKsErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                  {this.state.budgetedKsErrorData}
                                                                  </span>
                                                               </div>
                                                            </div>
                                                         </div>
                                                    </div>
                                                */}

                                               <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.statusSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.statusComponent = el}>
                                                              <EntityStatus type="STORES" entityStatusChange={this.entityStatusChange} selectedValue={this.state.status} />
                                                              <span className="help-block" style={{ display: this.state.statusErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.statusErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                                </div>

                                                 <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.businessStatusSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Business Status *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.businessStatusComponent = el}>
                                                              <EntityStatus type="BUSINESS_STATUS" entityStatusChange={this.businessStatusChange} selectedValue={this.state.businessStatus} />
                                                              <span className="help-block" style={{ display: this.state.businessStatusErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.businessStatusErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                                </div>


                                                 <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Business Remarks</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter Business Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>




                                                </div>

                                            )
                                        }
                                })()}

                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                     {(() => {
                                        if(!this.state.editFlag){
                                            return (


                                    <div className="box box-info" style={{ borderTop: "0px" }}>
                                          <div className="box-header with-border">
                                             <h3 className="box-title" style={{ fontWeight: 600 }}>Store Timing</h3>
                                          </div>
                                            <div className="form-horizontal">
                                                 <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>   
                                                     <div className="col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "1%"}}>
                                                     

                                                            {(() => {
                                                                    if(this.state.storeTimings.length<2){
                                                                        return (
                                                                                     <button
                                                                                        style={{
                                                                                            background: "#fbc210",border: "1px solid #fbc210",color: "white"
                                                                                        }}
                                                                                        className="btn btn-default"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault()
                                                                                            this.addTimingBtn()
                                                                                        }}>
                                                                                        <i className="fa fa-clock-o" aria-hidden="true"></i> Add Timing
                                                                                    </button>
                                                                                )
                                                                    }
                                                            })()}

                                                     </div>

                                                      {(() => {
                                                                    if(this.state.storeTimings.length>0){
                                                                        return (

                                                     <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <table className="table table-bordered" style={{textAlign:"left"}}>
                                                        
                                                                            <thead>
                                                                                <tr><th>Start Time</th><th>Endt Time</th><th>Next Day</th><th>Delete</th></tr>
                                                                            </thead>
                                                                            <tbody>
                                                                             {this.state.storeTimings.map((item, index) => (

                                                                            <tr>
        <td>
        <TimePicker clearIcon={this.state.clearIcon} format="H:mm"  onChange={(value, e) => this.startTimeChange(value, e,index)} value={this.state.storeTimings[index]['start_time']} className="react-time-picker" disableClock="false"/>
        </td>

        <td>
        <TimePicker clearIcon={this.state.clearIcon} format="H:mm"  onChange={(value, e) => this.endTimeChange(value, e ,index)} value={this.state.storeTimings[index]['end_time']} className="react-time-picker" disableClock="false"/>
        </td>

                                                                            <td><input className="checkbox" type="checkbox" name="checkbox" value="value" style={{"float": "left"}} checked={this.state.storeTimings[index]['end_day']} 
                                                                            onChange={(e) => {
                                                                                this.checkBoxChange(index,e)
                                                                            }}
                                                                            /></td>
                                                                            <td>
                                                                            <button
                                                                            className="btn btn-danger"
                                                                            onClick={(e) => {
                                                                                e.preventDefault()
                                                                                this.removeStoreTiming(index)
                                                                            }}>
                                                                            X
                                                                        </button></td>

                                                                            </tr>

                                                                            ))}
                                                                            </tbody>

                                                                </table>
                                            </div>
                                            )

                                              }
                                            })()}


                                                 </div>
                                             </div>
                                    </div>

                                     )
                                                                    }
                                                            })()}


                                                             <div className="box box-info" style={{ borderTop: "0px" }}>
                                    <div className="box-header with-border">

                                     {(() => {
                                        if(this.state.editFlag){
                                            return(
                                                <h3 className="box-title" style={{ fontWeight: 600 }}>Selected Platforms</h3>
                                            )
                                        }else{
                                            return(
                                                <h3 className="box-title" style={{ fontWeight: 600 }}>Select Platforms</h3>
                                            )
                                        }
                                    })()}

                                    </div>
                                    <div className="row" style={{marginTop:"2%"}}>

                                    <div className="col-md-12">
                                    <div className="col-md-6 col-md-offset-1">

                                                <table className="table table-bordered" style={{textAlign:"left"}}>
                                    
                                                        <thead>
                                                            <tr>
                                                                <th style={{width:"30%"}}>Platforms</th>
                                                                <th>Availability</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                         {this.state.platformsListData.map((item, index) => (

                                                            <tr>
                                                                <td>{this.state.platformsListData[index].name}</td>
                                                                <td>
                                                                <input className="checkbox" type="checkbox" name="checkbox" value="value" style={{"float": "left"}} checked={this.state.platformsListData[index].available} 
                                                                onChange={(e) => {
                                                                    this.checkBoxPlaformChange(this.state.platformsListData[index].platform_id,e)
                                                                }}
                                                                />
                                                                </td>

                                                                
                                                            
                                                            </tr>
                                                            ))}
                                                        </tbody>
                                                        </table>

                                        

                                    </div>
                                    </div>
                                    </div>

                                </div>



                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>

                                         {(() => {
                                                if(this.state.editFlag){
                                                    return(

                                                    <button
                                                        className="btn btn-info pull-right"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.onSaveClick()
                                                        }}>
                                                        Update Store
                                                    </button>

                                                    )
                                                }else{
                                                     return(

                                                    <button
                                                        className="btn btn-info pull-right"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.onSaveClick()
                                                        }}>
                                                        Add Store
                                                    </button>

                                                    )
                                                }
                                             })()}



                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        stores: state.stores,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditStore))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/AddEditStore.js